import BillBatchIcon from '@material-ui/icons/ViewList';

import BankTransferConsolidateList from './BankTransferTopupConsolidateList';

export default {
  list: BankTransferConsolidateList,
  icon: BillBatchIcon,
};
